const SHOW_SENDING_ERROR = 'SHOW_ERROR_ALERT'

const setShowSendingError = (data: boolean) => {
  return { type: SHOW_SENDING_ERROR, payload: data }
}

export { SHOW_SENDING_ERROR, setShowSendingError }
